<template>
  <div>
    <gg-loading v-if="setUp === null" :loading="true" type="card" />
    <!-- Auto reply is the one feature whose Create opens the full form rather
         than a modal (AM-1107). -->
    <feature-setup v-else-if="!setUp" feature="autoresponders" @create="openForm({ first: true })" />
    <!-- The form only shows while creating or editing; otherwise the list
         alone, with Create in its header. -->
    <add-responder
      v-else-if="form.open"
      :edit="form.edit"
      :email="form.email"
      @change="closeForm"
    />
    <autoresponder-table v-else title="Auto Replies" @edit="openForm">
      <template v-slot:header-actions>
        <gg-btn secondary small class="my-1" @click="openForm()">
          <v-icon left small>mdi-plus</v-icon>Create Auto Reply
        </gg-btn>
      </template>
    </autoresponder-table>
  </div>
</template>

<script>
import AddResponder from '@/components/Services/Hosting/Shared/Email/Autoresponders/AddResponder'
import AutoresponderTable from '@/components/Services/Hosting/Shared/Email/Autoresponders/AutoresponderTable'
import FeatureSetup from '@/components/Email/FeatureSetup'
import emailFeatureSetup from '@/mixins/emailFeatureSetup'

// The hosting section's auto reply form and list, shown inside an email
// account, behind the empty state while the account has none.
export default {
  name: 'AccountAutorespondersView',
  components: { AddResponder, AutoresponderTable, FeatureSetup },
  mixins: [emailFeatureSetup('hasAutoResponders')],
  // Passed down by EmailAccountView, which has already pointed the hosting
  // context at this account's service.
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      form: {
        open: false,
        edit: false,
        email: '',
        // Opened from the empty state, so nothing may exist yet.
        first: false,
      },
    }
  },
  methods: {
    // With no argument it creates; the table's `edit` event passes the rule.
    openForm ({ edit = false, email = '', first = false } = {}) {
      this.form = { open: true, edit, email, first }
      this.startSetUp()
    },
    // AddResponder emits `change` both after saving and on Cancel. If the
    // form came from the empty state, ask again: a cancelled first one leaves
    // nothing to list, and the empty state should come back.
    closeForm () {
      const { first } = this.form
      this.form = { open: false, edit: false, email: '', first: false }
      if (first) this.checkSetUp()
    },
  },
}
</script>
